export const COMPANY_SIZES = [
  {
    label: '1-4',
    value: '1-4',
    text: '1-4',
  },
  {
    label: '5-20',
    value: '5-20',
    text: '5-20',
  },
  {
    label: '21-100',
    value: '21-100',
    text: '21-100',
  },
  {
    label: '101-250',
    value: '101-250',
    text: '101-250',
  },
  {
    label: '251-500',
    value: '251-500',
    text: '251-500',
  },
  {
    label: '>501',
    value: '>501',
    text: '>501',
  },
]
